import {keccak256} from "js-sha3";

export function ethereumToChecksumAddress (address: string) {
  address = address.toLowerCase().replace('0x','');
  const addressHash = keccak256(address);
  let checksumAddress = '0x';

  for (let i = 0; i < address.length; i++ ) {
    // If ith character is 9 to f then make it uppercase
    if (parseInt(addressHash[i], 16) > 7) {
      checksumAddress += address[i].toUpperCase();
    } else {
      checksumAddress += address[i];
    }
  }
  return checksumAddress;
}
